<section class="hero107">
    <div class="hero107-overlay"></div>
    <div class="hero107-inner">
        <div class="hero107-texto">
            <div class="hero107-badge"><span class="hero107-punto"></span> Temporada en progreso</div>
            <h1 class="hero107-titulo">Liga Infantil<br>y Juvenil<br><span class="hero107-titulo-amarillo">de Béisbol</span></h1>
            <div class="hero107-divisor">
                <span class="hero107-linea-corta"></span>
                <span class="hero107-divisor-texto">Yucatán A.C. · México</span>
            </div>
            <p class="hero107-desc">Formando campeones dentro y fuera del campo. Béisbol infantil y juvenil para todas las edades.</p>
            <div class="hero107-botones">
                <a [routerLink]="['/landing/calendario']" class="hero107-btn-amarillo">Calendario de juegos <i class="fas fa-arrow-right"></i></a>
                <a [routerLink]="['/landing/estadisticas']" class="hero107-btn-borde">Ver estadísticas</a>
            </div>
            <div class="hero107-links">
                <a [routerLink]="['/landing/resultados-107']">Resultados 107</a>
                <span>·</span>
                <a [routerLink]="['/landing/reglas']">Reglamento</a>
            </div>
        </div>
    </div>
</section>

<div class="home-cuerpo">
    <div class="home-inner">

        <a [routerLink]="['/landing/resultados-107']" class="banner107">
            <div class="banner107-icono"><i class="fas fa-trophy"></i></div>
            <div class="banner107-texto">
                <span class="banner107-nuevo text-one">NUEVO</span>
                <p class="banner107-titulo text-one-sub">RESULTADOS GLOBALES · TEMPORADA 107</p>
                <p class="banner107-sub">Standing, resultados por jornada, bateo y pitcheo y campeones individuales</p>
            </div>
            <div class="banner107-accion text-one"><i class="fas fa-lock"></i> VER CON CLAVE <i class="fas fa-arrow-right"></i></div>
        </a>

        <div class="home-anuncio-movil d-lg-none">
            <a href="./assets/anuncios/anuncio-liga-yucatan.jpg" target="_blank" class="anuncio107-link">
                <img src="./assets/anuncios/anuncio-liga-yucatan.jpg" alt="Anuncio Liga Yucatán" class="anuncio107-img">
            </a>
        </div>

        <div class="home-grid">

            <div class="home-principal">
                <div class="home-seccion-head">
                    <div class="home-titulo-wrap">
                        <span class="home-barra"></span>
                        <h2 class="home-titulo">Resultados <span class="home-titulo-cat" *ngIf="categoria">· {{categoria}}</span></h2>
                    </div>
                    <div class="home-filtros">
                        <div ngbDropdown class="home-dd">
                            <button class="home-dd-btn" ngbDropdownToggle><i class="fas fa-layer-group"></i> Categoría <i class="fas fa-chevron-down home-dd-caret"></i></button>
                            <div ngbDropdownMenu class="home-dd-menu">
                                <button class="home-dd-item" *ngFor="let categoria of Categorias" (click)="mostrarCategoria(categoria.CategoriaID)" ngbDropdownItem>{{categoria.Categoria}}</button>
                            </div>
                        </div>
                        <div ngbDropdown class="home-dd">
                            <button class="home-dd-btn" ngbDropdownToggle><i class="far fa-calendar"></i> Jornada <i class="fas fa-chevron-down home-dd-caret"></i></button>
                            <div ngbDropdownMenu class="home-dd-menu home-dd-menu-scroll">
                                <button class="home-dd-item" *ngFor="let jor of Jornadas" (click)="seleccionarJornadas(jor.JornadaID)" ngbDropdownItem>{{jor.Jornada_Vista}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <form class="home-buscador">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Buscar equipo</mat-label>
                        <input type="text" placeholder="Escribe el nombre de un equipo" [formControl]="myControl" (keyup)="buscarEquipo()" matInput [matAutocomplete]="auto">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="EquipoSeleccionado($event.option.id)">
                            <mat-option *ngFor="let equipo of Equipos" [id]="equipo.InscripcionID" [value]="equipo.Equipo">
                                {{equipo.Equipo}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </form>

                <div class="home-vacio" *ngIf="!lastesdGames || lastesdGames.length === 0">
                    <i class="fas fa-baseball-ball"></i>
                    <p>No hay resultados para mostrar en esta selección.</p>
                </div>

                <div class="home-partido" *ngFor="let lastGame of lastesdGames">
                    <div class="home-partido-top">
                        <span class="home-partido-ubi">{{lastGame.ubicacion}}</span>
                        <span class="home-partido-temp">{{lastGame.temporada}}</span>
                    </div>
                    <div class="home-partido-cuerpo">
                        <div class="home-eq">
                            <img class="home-eq-logo" [src]="lastGame.equipo_1.logo || placeholderEquipo" (error)="onLogoError($event)">
                            <span class="home-eq-nombre" [class.home-eq-gana]="lastGame.equipo_1.win">{{lastGame.equipo_1.equipo}}</span>
                        </div>
                        <div class="home-marcador">
                            <span class="home-carreras" [class.home-eq-gana]="lastGame.equipo_1.win">{{lastGame.equipo_1.carreras}}</span>
                            <span class="home-vs">VS</span>
                            <span class="home-carreras" [class.home-eq-gana]="lastGame.equipo_2.win">{{lastGame.equipo_2.carreras}}</span>
                        </div>
                        <div class="home-eq home-eq-der">
                            <span class="home-eq-nombre" [class.home-eq-gana]="lastGame.equipo_2.win">{{lastGame.equipo_2.equipo}}</span>
                            <img class="home-eq-logo" [src]="lastGame.equipo_2.logo || placeholderEquipo" (error)="onLogoError($event)">
                        </div>
                    </div>
                    <p class="home-cronica" *ngIf="lastGame.cronicas"><i class="fas fa-quote-left"></i> {{lastGame.cronicas}}</p>
                </div>
            </div>

            <aside class="home-sidebar">
                <div class="home-anuncio d-none d-lg-block">
                    <div class="home-titulo-wrap">
                        <span class="home-barra"></span>
                        <h2 class="home-titulo">Anuncios</h2>
                    </div>
                    <a href="./assets/anuncios/anuncio-liga-yucatan.jpg" target="_blank" class="anuncio107-link">
                        <img src="./assets/anuncios/anuncio-liga-yucatan.jpg" alt="Anuncio Liga Yucatán" class="anuncio107-img">
                    </a>
                </div>

                <div class="home-titulo-wrap">
                    <span class="home-barra"></span>
                    <h2 class="home-titulo">Tabla de posiciones</h2>
                </div>
                <div class="home-tabla-grupo" *ngFor="let posicion of TablaPosicion">
                    <div class="home-tabla-titulo">Posiciones {{posicion.clasificacion}}</div>
                    <div class="home-tabla-wrap">
                        <table class="home-tabla">
                            <thead>
                                <tr>
                                    <th class="home-tabla-pos">#</th>
                                    <th></th>
                                    <th class="home-tabla-eq">Equipo</th>
                                    <th>G</th>
                                    <th>P</th>
                                    <th>%</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let equipo of posicion.equipos">
                                    <td class="home-tabla-pos">{{equipo.position}}</td>
                                    <td><img [src]="equipo.foto || placeholderEquipo" (error)="onLogoError($event)" class="home-tabla-logo"></td>
                                    <td class="home-tabla-eq">{{equipo.equipo}}</td>
                                    <td>{{equipo.wins}}</td>
                                    <td>{{equipo.loses}}</td>
                                    <td class="home-tabla-pct">{{equipo.points}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </aside>

        </div>
    </div>
</div>
